import { LineSkeleton } from "./LineSkeleton";

export const LinesSkeleton = () => {
  return (
    <div>
      {Array.from({ length: 8 }, (_, index) => (
        <LineSkeleton key={index} />
      ))}
    </div>
  );
};
